import configLib from '../../../configLib';
import { parsingResponseFailed } from '../../store/gateway';
import { updateNBBOPricesCache } from '../../store-util/NBBOPriceCache';
import { parseGatewayData } from '../../util/GatewayHelpers';
import { dataArrayToMap } from '../../util/MarketDataHelpers';
import { WebSocketEventData } from '../custom-event/types';
import { LoggerService } from '../logger/Logger.service';
import { GatewayRequestType, GatewayResponseSubType, GatewayResponseType } from '../web-socket/types';

import { BaseSymbolSubscriptionService } from './BaseSymbolSubscription.service';
import { SymbolSubscriptionRequestType } from './types';

const LOG_PREFIX = '[NBBO-SUBS]';
const logger = LoggerService.getLogger();

/**
 * NBBO Subscription Service
 */
export class NBBOSubscriptionService extends BaseSymbolSubscriptionService<SymbolSubscriptionRequestType> {
  private static instance: NBBOSubscriptionService;

  // Make the constructor private, to have a single instance
  // eslint-disable-next-line no-useless-constructor
  private constructor() {
    super();
  }

  static getInstance(): NBBOSubscriptionService {
    if (!this.instance) {
      this.instance = new NBBOSubscriptionService();
    }

    return this.instance;
  }

  // TODO: HW-1162  Cover all cases with unittesting
  public handleResponseEvent = (event: WebSocketEventData<any>): void => {
    // Only handle NBBO subscription responses for market data
    if (
      event.data.messageType !== GatewayResponseType.MarketData
      || event.data.messageSubType !== GatewayResponseSubType.Nbbo
    ) {
      return;
    }

    const data = event.data ?? {};
    let parsedData;

    try {
      parsedData = parseGatewayData(data.arrayData);
    } catch (error) {
      configLib.store.dispatch(parsingResponseFailed(`${error}`));
      return;
    }

    logger.log(`${LOG_PREFIX} NBBOSubscriptionService response! data:`, event);
    parsedData = {
      raw: data,
      final: dataArrayToMap(parsedData),
    };

    updateNBBOPricesCache(parsedData.final, 'nbbo');
  };

  protected getResponseType = (): GatewayResponseType => GatewayResponseType.MarketData;

  protected getSubscriptionRequestType = (): GatewayRequestType => GatewayRequestType.MarketDataSubscribeNbbo;

  protected getUnsubscriptionRequestType = (): GatewayRequestType => GatewayRequestType.MarketDataUnsubscribeNbbo;
}
